import { InspirationTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import type { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import { EARLY_FREEDOM_IMAGE } from "web_myplann/Inspiration/EarlyFreedom/constants";
import { OWN_HOME_IMAGE } from "web_myplann/Inspiration/OwnHome/constants";
import { RETIREMENT_IMAGE } from "web_myplann/Inspiration/Retirement/constants";

export type InspirationCard = {
	id: InspirationTypeEnum;
	titleKey: keyof typeof Resources.Dashboard.Inspiration.Cards;
	image: string;
};

export const INSPIRATION_CARDS: InspirationCard[] = [
	{
		id: InspirationTypeEnum.OwnHome,
		titleKey: "ownHome",
		image: OWN_HOME_IMAGE,
	},
	{
		id: InspirationTypeEnum.EarlyFreedom,
		titleKey: "earlyFreedom",
		image: EARLY_FREEDOM_IMAGE,
	},
	{
		id: InspirationTypeEnum.Retirement,
		titleKey: "retirement",
		image: RETIREMENT_IMAGE,
	},
];
